var map = {
	"./HTML.png": 90,
	"./JS.png": 128,
	"./about-me.jpg": 672,
	"./arrow-right.png": 133,
	"./blooper.gif": 339,
	"./blooper10.gif": 68,
	"./blooper11.gif": 809,
	"./blooper2.gif": 998,
	"./blooper4.gif": 260,
	"./blooper5.gif": 936,
	"./blooper6.gif": 230,
	"./blooper7.gif": 205,
	"./blooper8.gif": 450,
	"./blooper9.gif": 190,
	"./calculator.png": 140,
	"./css.png": 605,
	"./eCommerce.png": 162,
	"./eCommerce2.png": 975,
	"./eCommerce3.png": 56,
	"./framer-motion-logo.png": 170,
	"./git.png": 607,
	"./gsap-logo.jpg": 224,
	"./icon-parallax.png": 99,
	"./inventory.png": 999,
	"./logonext.png": 328,
	"./mysqllogo.png": 637,
	"./perfil2.jpg": 431,
	"./react.png": 47,
	"./redux.png": 402,
	"./stopwatch.png": 336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;